import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

export default function SimpleContainer({ className, children, ...rest }) {
  return <div className={cn('flex flex-col gap-2', className)} {...rest}>{children}</div>;
}

SimpleContainer.propTypes = {
  className: propTypes.string,
  children: propTypes.node.isRequired
};
